// extracted by mini-css-extract-plugin
module.exports = {"health-order-message":"health-order-message-47baec300f71d980036c62cc739cb9ab","health-order-message-all":"health-order-message-all-04ecc7f5243042ac78871377a8fcb6c4"};